import { render, staticRenderFns } from "./NpsPage.vue?vue&type=template&id=5c7aa5ed&scoped=true&lang=pug&"
import script from "./NpsPage.vue?vue&type=script&lang=js&"
export * from "./NpsPage.vue?vue&type=script&lang=js&"
import style0 from "./NpsPage.vue?vue&type=style&index=0&id=5c7aa5ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7aa5ed",
  null
  
)

export default component.exports